import { useMutation } from "react-query";
import { useDispatch } from "react-redux";
import {
  createAuthenticatedRequest,
  defaultMutationOptions,
  executeRequest,
} from "./utils";

export const SERVICES_PATH = "services";

export function useInstagramRescrapeUsers() {
  const dispatch = useDispatch();

  const path = `${SERVICES_PATH}/instagram/rescrapeUsers?saveProfilePic=true`;

  return useMutation(body => rescrapeUsers(path, body, dispatch), {
    ...defaultMutationOptions,
  });
}

// Execute a PUT request to rescrapeUsers
export async function rescrapeUsers(path, body, dispatch) {
  const requestObject = await createAuthenticatedRequest(path, dispatch, {
    method: "PUT",
    body: JSON.stringify(body),
  });

  return executeRequest(requestObject);
}

export function useScrapeLink() {
  const dispatch = useDispatch();

  const path = `${SERVICES_PATH}/scrapeLink`;

  return useMutation(body => scrapeLink(path, body, dispatch), {
    ...defaultMutationOptions,
  });
}

// Execute a POST request to scrapeLink
export async function scrapeLink(path, body, dispatch) {
  const requestObject = await createAuthenticatedRequest(path, dispatch, {
    method: "POST",
    body: JSON.stringify(body),
  });

  const response = await fetch(requestObject);
  if (!response.ok) {
    const json = await response.json();
    throw new Error(json.message || response.statusText);
  }
  return response.text();
}
